import {
  Header,
  Paragraph
} from '@eggplant/pattern-library'

const TestCasesStepRunTimeInfo = () =>
  <div className='grid gap-3'>
    <Header
      hasNoBottomMargin
      hasNoTopMargin
      rank={5}
    >
      Test cases step run time
    </Header>
    <Paragraph>
      This table shows the runtime data of test case
      steps in the test cases of the selected monitor configuration.
    </Paragraph>
  </div>

export default TestCasesStepRunTimeInfo
